import { Apollo } from 'apollo-angular';
import { setContext } from 'apollo-link-context';
import { HttpLink } from 'apollo-angular-link-http';
import { createPersistedQueryLink } from 'apollo-link-persisted-queries';
import { onError } from 'apollo-link-error';
import { environment } from './../../../environments/environment';
import { ErrorHandlingService } from '../services/error-handling.service';
import { PersistorService } from './persistor.service';
import { from } from 'apollo-link';
import { JwtService } from '../services';
var GraphQlModule = /** @class */ (function () {
    function GraphQlModule(apollo, httpLink, errorHandlingService, persistorService, jwtService) {
        var _this = this;
        this.apollo = apollo;
        this.httpLink = httpLink;
        this.errorHandlingService = errorHandlingService;
        this.persistorService = persistorService;
        this.jwtService = jwtService;
        var networkLink = createPersistedQueryLink().concat(this.httpLink.create({
            uri: environment.API_URL + "/graphql",
        }));
        var authLink = setContext(function () {
            var token = _this.jwtService.getToken();
            if (!token) {
                return {};
            }
            else {
                return {
                    headers: { Authorization: "Token " + token },
                };
            }
        });
        var errorLink = onError(function (_a) {
            var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
            if (graphQLErrors) {
                _this.errorHandlingService.errors.next(graphQLErrors);
            }
            if (networkError) {
                _this.errorHandlingService.errors.next(networkError);
                // this.jwtService.destroyToken();
            }
        });
        this.apollo.create({
            link: from([authLink, errorLink, networkLink]),
            cache: this.persistorService.cache,
            defaultOptions: {
                watchQuery: { fetchPolicy: 'cache-first', errorPolicy: 'all' },
                query: { fetchPolicy: 'network-only', errorPolicy: 'all' },
                mutate: { errorPolicy: 'all' },
            },
        });
    }
    return GraphQlModule;
}());
export { GraphQlModule };
